<prism-anchor-position id="sh-header-toolbar-notifications-anchor" [visible]="isNotificationsEnabled()">
	<prism-badge
		[disabled]="notificationsCount() === 0"
		id="sh-header-toolbar-notifications-badge"
		slot="anchor-target"
	>
		<prism-icon-button
			icon="notifications"
			label="notifications"
			tooltip-disabled
			(click)="openNotifications()"
			id="sh-header-toolbar-notifications-icon"
		>
		</prism-icon-button>
	</prism-badge>
	<prism-overlay>
		@if (isNotificationsEnabled()) {
			<sh-notifications-popup
				[application]="application"
				(closeNotificationPopup)="handlePopupClose()"
			></sh-notifications-popup>
		}
	</prism-overlay>
</prism-anchor-position>
